<template>
  <div class="clock-wrap">
    <span class="clock-date">{{ date }}</span>
    <span class="clock-divider">|</span>
    <span class="clock-time">{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: 'Clock',
  data() {
    return {
      time: '',
      date: '',
      week: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      timerID: null
    }
  },
  mounted() {
    this.updateTime()
    this.timerID = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timerID)
  },
  methods: {
    pad(num, digit) {
      return (String('0').repeat(digit) + num).slice(-digit)
    },
    updateTime() {
      const cd = new Date()
      this.time = `${this.pad(cd.getHours(),2)}:${this.pad(cd.getMinutes(),2)}:${this.pad(cd.getSeconds(),2)}`
      this.date = `${cd.getFullYear()}-${this.pad(cd.getMonth()+1,2)}-${this.pad(cd.getDate(),2)} ${this.week[cd.getDay()]}`
    }
  }
}
</script>

<style scoped>
.clock-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  background: #f5f5f5;
  white-space: nowrap;
}
.clock-date {
  font-size: 12px;
  color: #888;
  font-variant-numeric: tabular-nums;
}
.clock-divider {
  font-size: 11px;
  color: #ccc;
}
.clock-time {
  font-size: 12px;
  font-weight: 500;
  color: #b3450e;
  font-variant-numeric: tabular-nums;
}
</style>